import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import adicionarPassageirosVolta from '../../actions/passageiro/adicionarPassageirosVolta';
import selecionarPassageiro from '../../actions/passageiro/selecionarPassageiro';
import buscarOpcaoDescontoMeiaPassagem from '../../actions/usuario/buscarOpcaoDescontoMeiaPassagem';

import {removerAcentos, renderFieldCheck, renderFieldText} from '../../util/inputs';
import adicionarDadosComprador from '../../actions/viagem/adicionarDadosComprador';
import ModalIncluirPassageiro from './ModalIncluirPassageiro';
import adicionarPassageirosIda from '../../actions/passageiro/adicionarPassageirosIda';
import selecionarPoltronas from '../../actions/poltrona/selecionarPoltronas'
import poltronaGratuiraDisponivel from '../../actions/reserva/poltronaGratuitaDisponivel';
import selecionarTiposEmisssoes from '../../actions/tipo-emissao/selecionarTiposEmisssoes';
import {alterarPassageiroIda, alterarCompradorIda} from '../../actions/passageiro/alterarPassageiroIda';
import {alterarPassageiroVolta, alterarCompradorVolta} from '../../actions/passageiro/alterarPassageiroVolta';
import vendaSeguroHabilitada from '../../actions/viagem/vendaSeguroHabilitada';
import {
    TIPOS_EMISSAO_ACOMPANHANTE,
    TIPOS_EMISSAO_CORTESIA,
    TIPOS_EMISSAO_ID_JOVEM_50,
    TIPOS_EMISSAO_IDOSO_50,
    TIPOS_EMISSAO_ID_JOVEM_100,
    TIPOS_EMISSAO_DEFICIENTE,
    TIPOS_EMISSAO_IDOSO_100,
    TIPOS_EMISSAO_P_LIVRE_POLICIAL_AUDITOR,
    TIPOS_EMISSOES,
} from './TiposEmissoes';
import {validaPerfis} from '../../security/Autorizacao';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa} from '../../security/securityContext';
import { paisesDDI, EMPRESAS_SEM_LIMITE_VENDA_GRATUIDADE_50 } from '../../util/constantsUtil';
import buscarUsuarioPorEmpresaNomeIdEmail from '../../actions/usuario/buscarUsuarioEmpresaPorParte';
import buscarConfigGratuidadeTipoPreco from '../../actions/empresa/buscarConfigGratuidadeTipoPreco';

export const validate = (values) => {
    const errors = {};
    if (!values.nome) {
        errors.nome = 'Campo obrigatório'
    }
    if (!values.email) {
        errors.email = 'Campo obrigatório'
    }

    return errors
};

export class AbaPassageiro extends React.Component {
    constructor(props) {
        super(props);
        this.limparFormulario = this.limparFormulario.bind(this);

        this.state = {
            naoHabilitadoCpfPassageiro: false,
            configGratuidade: []
        };
        this.processingPagador = false;
    }

    componentDidMount() {
        this.props.adicionarDadosComprador(null);
        this.props.buscarOpcaoDescontoMeiaPassagem(this.props.empresaSelecionada.id);
        this.props.changeFieldValue('formIncluirPassageiro', 'preencherComDadosIda', false);
        if (!this.props.online) {
            this.setState({ naoHabilitadoCpfPassageiro: true });
            this.props.changeFieldValue('formIncluirPassageiro', 'naoHabilitadoCpfPassageiro', true);
        }
        this.props.buscarConfigGratuidadeTipoPreco(this.props.empresaSelecionada.id)
            .then(resp => {
                if (resp.payload && resp.payload.data) {
                    this.setState({ configGratuidade: resp.payload.data });
                }
            });
    }

    componentDidUpdate(prevProps, prevState) {
        const {passageirosIda, passageirosVolta} = this.props
        if (this.props.passagueiroSelecionado && this.props.passagueiroSelecionado !== prevProps.passagueiroSelecionado) {
            let ehEdicao = false;
            let idItinerario = this.props.passagueiroSelecionado.sentido === 'IDA' ? this.props.ida.idItinerario : this.props.volta.idItinerario;
            if (this.props.passagueiroSelecionado.nome !== undefined && this.props.passagueiroSelecionado.tipoEmissao !== undefined) {
                if (this.props.ehIdoso100(this.props.passagueiroSelecionado.tipoEmissao) || this.props.ehIdJovem100(this.props.passagueiroSelecionado.tipoEmissao)
                    || this.props.ehIdJovem50(this.props.passagueiroSelecionado.tipoEmissao) || this.props.ehIdoso50(this.props.passagueiroSelecionado.tipoEmissao)
                    || this.props.ehDeficiente(this.props.passagueiroSelecionado.tipoEmissao)) {
                    ehEdicao = true
                }
            }
            this.exibirOpcoesGratuidade(ehEdicao, idItinerario)
                .then(() => this.preencherValoresParaEdicao(this.props.passagueiroSelecionado));
            this.props.vendaSeguroHabilitada(this.props.empresaSelecionada.id).then(resp => {
                this.props.habilitarVendaSeguro(resp.payload.data)
                this.props.changeFieldValue('formIncluirPassageiro', 'vendaSeguro', resp.payload.data);
            })
            if (this.ehGratuidadeTotal(this.props.tipoEmissao)) {
                this.props.changeFieldValue('formIncluirPassageiro', 'vendaSeguro', false);
                this.props.habilitarVendaSeguro(false)
            }
        }

        if (this.props.passagueiroSelecionado && prevState.configGratuidade !== this.state.configGratuidade) {
            let ehEdicao = false;
            let idItinerario = this.props.passagueiroSelecionado.sentido === 'IDA' ? this.props.ida.idItinerario : this.props.volta.idItinerario;
            if (this.props.passagueiroSelecionado.nome !== undefined && this.props.passagueiroSelecionado.tipoEmissao !== undefined) {
                if (this.props.ehIdoso100(this.props.passagueiroSelecionado.tipoEmissao) || this.props.ehIdJovem100(this.props.passagueiroSelecionado.tipoEmissao)
                    || this.props.ehIdJovem50(this.props.passagueiroSelecionado.tipoEmissao) || this.props.ehIdoso50(this.props.passagueiroSelecionado.tipoEmissao)
                    || this.props.ehDeficiente(this.props.passagueiroSelecionado.tipoEmissao)) {
                    ehEdicao = true
                }
            }
            this.exibirOpcoesGratuidade(ehEdicao, idItinerario);
        }
        if (passageirosIda) {
            passageirosIda.map(passageiro =>
                this.setVendaSeguro(passageiro)
            )
        }
        if (passageirosVolta) {
            passageirosVolta.map(passageiro =>
                this.setVendaSeguro(passageiro)
            )
        }

        // Auto-seleciona primeiro passageiro como pagador quando ainda não há comprador
        const primeiroPassageiro = passageirosIda && passageirosIda[0];
        const primeiroAnterior = prevProps.passageirosIda && prevProps.passageirosIda[0];
        const semComprador = !this.props.dadosPagamento || !this.props.dadosPagamento.cpfComprador;
        if (primeiroPassageiro && primeiroPassageiro.nome && semComprador && primeiroPassageiro !== primeiroAnterior) {
            this.handleRadioPagador(primeiroPassageiro);
        }

    }

    setVendaSeguro(passageiro) {
        return this.props.changeFieldValue('formIncluirPassageiro', `vendaSeguro-${passageiro.poltronaId}`, passageiro.vendaSeguro);
    }

    limparMensagem() {
        this.setState({mensagem: undefined})
    }

    ehGratuidadeTotal(tipoEmissao) {
        return tipoEmissao === 'ID_JOVEM_100'
            || tipoEmissao === 'IDOSO_100'
            || tipoEmissao === 'DEFICIENTE'
            || tipoEmissao === 'P_LIVRE_POLICIAL_AUDITOR'
            || tipoEmissao === 'CORTESIA'
    }

    limparFormulario() {
        this.props.reset('formReserva');
        this.limparMensagem();
    }

    recuperarTipoEmissaoPassageiro(tipoEmissao) {
        if (tipoEmissao) {
            const tipo = tipoEmissao.value ? tipoEmissao.value : tipoEmissao;
            return this.props.tiposEmissoesSelecionados.filter(f => f.value === tipo)[0]
        }
        return {
            label: 'Normal',
            value: 'NORMAL'
        }
    }

    isGratuidadePermitida(tipoEmissao, tipoVeiculo) {
        const config = this.state.configGratuidade.find(c => c.tipoEmissao === tipoEmissao);
        if (!config || !config.tiposPrecoPermitidos || config.tiposPrecoPermitidos.length === 0) return false;
        if (config.tiposPrecoPermitidos.includes('TODAS')) return true;
        return config.tiposPrecoPermitidos.includes(tipoVeiculo);
    }

    exibirOpcoesGratuidade(ehEdicao, idItinerario) {
        if (this.props.passagueiroSelecionado) {
            return this.props.poltronaGratuiraDisponivel(this.props.empresaSelecionada.id, idItinerario)
                .then(() => {
                    const tipoVeiculo = this.props.passagueiroSelecionado.sentido === 'IDA'
                        ? this.props.ida.tipoVeiculo
                        : this.props.volta.tipoVeiculo;

                    let retorno = TIPOS_EMISSOES;
                    if (this.props.passagueiroSelecionado.sentido === 'IDA') {
                        if (this.props.totaisGratuidade.usuarioVendeGratuidade) {
                            retorno = this.incluirTiposGratuidade(retorno, ehEdicao, this.props.passageirosIda)
                        }
                    }
                    if (this.props.passagueiroSelecionado.sentido === 'VOLTA') {
                        if (this.props.totaisGratuidade.usuarioVendeGratuidade) {
                            retorno = this.incluirTiposGratuidade(retorno, ehEdicao, this.props.passageirosVolta)
                        }
                    }

                    if (this.exibirTipoEmissaoAcompanhante(ehEdicao) && this.isGratuidadePermitida('ACOMPANHANTE', tipoVeiculo)) {
                        retorno = retorno.concat(TIPOS_EMISSAO_ACOMPANHANTE);
                    }
                    const perfisPermitidosCortesia = [getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getGestorEmpresa(this.props.empresaSelecionada.id)];
                    if (validaPerfis(perfisPermitidosCortesia) && this.isGratuidadePermitida('CORTESIA', tipoVeiculo)) {
                        retorno = retorno.concat(TIPOS_EMISSAO_CORTESIA);
                        if (this.isGratuidadePermitida('P_LIVRE_POLICIAL_AUDITOR', tipoVeiculo)) {
                            retorno = retorno.concat(TIPOS_EMISSAO_P_LIVRE_POLICIAL_AUDITOR);
                        }
                    }
                    this.props.selecionarTiposEmisssoes(retorno);
                })
        }
    }

    exibirTipoEmissaoAcompanhante(ehEdicao) {
        let totalDeAcompanhantes = 0;
        let qtdPassageirosPermiteAcompanhantes = 0;
        if (this.props.passagueiroSelecionado.sentido === 'IDA') {
            totalDeAcompanhantes = this.props.passageirosIda.filter(f => f.tipoEmissao === 'ACOMPANHANTE').length;
            qtdPassageirosPermiteAcompanhantes = this.props.passageirosIda.filter(f => f.comAcompanhante).length
        }
        if (this.props.passagueiroSelecionado.sentido === 'VOLTA') {
            totalDeAcompanhantes = this.props.passageirosVolta.filter(f => f.tipoEmissao === 'ACOMPANHANTE').length;
            qtdPassageirosPermiteAcompanhantes = this.props.passageirosVolta.filter(f => f.comAcompanhante).length
        }
        if (ehEdicao) {
            return qtdPassageirosPermiteAcompanhantes > 0
                && totalDeAcompanhantes <= qtdPassageirosPermiteAcompanhantes
                && this.props.ehAcompanhante(this.props.passagueiroSelecionado.tipoEmissao)
        }

        return totalDeAcompanhantes < qtdPassageirosPermiteAcompanhantes;

    }

    incluirTiposGratuidade(retorno, ehEdicao, passageiros) {
        const tipoVeiculo = this.props.passagueiroSelecionado.sentido === 'IDA'
            ? this.props.ida.tipoVeiculo
            : this.props.volta.tipoVeiculo;

        let tipos = retorno;

        if (this.isGratuidadePermitida('IDOSO_100', tipoVeiculo)) {
            const qtdIdoso100 = this.qtdIdoso100(passageiros);
            if (qtdIdoso100 < 2 || (ehEdicao && qtdIdoso100 === 2)) {
                tipos = tipos.concat(TIPOS_EMISSAO_IDOSO_100);
            }
        }

        if (this.isGratuidadePermitida('ID_JOVEM_100', tipoVeiculo)) {
            const qtdIdJovem100 = this.qtdIdJovem100(passageiros);
            if (qtdIdJovem100 < 2 || (ehEdicao && qtdIdJovem100 === 2)) {
                tipos = tipos.concat(TIPOS_EMISSAO_ID_JOVEM_100);
            }
        }

        if (this.isGratuidadePermitida('ID_JOVEM_50', tipoVeiculo)) {
            const qtdIdJovem50 = this.qtdIdJovem50(passageiros);
            if (qtdIdJovem50 < 4 || (ehEdicao && qtdIdJovem50 === 4)
                || EMPRESAS_SEM_LIMITE_VENDA_GRATUIDADE_50.includes(this.props.empresaSelecionada.id)) {
                tipos = tipos.concat(TIPOS_EMISSAO_ID_JOVEM_50);
            }
        }

        if (this.isGratuidadePermitida('IDOSO_50', tipoVeiculo)) {
            const qtdIdoso50 = this.qtdIdoso50(passageiros);
            if (qtdIdoso50 < 4 || (ehEdicao && qtdIdoso50 === 4)
                || EMPRESAS_SEM_LIMITE_VENDA_GRATUIDADE_50.includes(this.props.empresaSelecionada.id)) {
                tipos = tipos.concat(TIPOS_EMISSAO_IDOSO_50);
            }
        }

        if (this.isGratuidadePermitida('DEFICIENTE', tipoVeiculo)) {
            tipos = tipos.concat(TIPOS_EMISSAO_DEFICIENTE);
        }

        return tipos;
    }

    qtdIdoso100(passageiros) {
        const total = this.props.totaisGratuidade ? this.props.totaisGratuidade.totalIdoso100 : 0;
        return passageiros.filter(f => this.props.ehIdoso100(f.tipoEmissao)).length + total
    }

    qtdIdJovem100(passageiros) {
        const total = this.props.totaisGratuidade ? this.props.totaisGratuidade.totalIdJovem100 : 0;
        return passageiros.filter(f => this.props.ehIdJovem100(f.tipoEmissao)).length + total
    }

    qtdIdJovem50(passageiros) {
        const total = this.props.totaisGratuidade ? this.props.totaisGratuidade.totalIdJovem50 : 0;
        return passageiros.filter(f => this.props.ehIdJovem50(f.tipoEmissao)).length + total
    }

    qtdIdoso50(passageiros) {
        const total = this.props.totaisGratuidade ? this.props.totaisGratuidade.totalIdoso50 : 0;
        return passageiros.filter(f => this.props.ehIdoso50(f.tipoEmissao)).length + total
    }

    qtdDeficiente(passageiros) {
        const total = this.props.totaisGratuidade ? this.props.totaisGratuidade.totalDeficiente : 0;
        return passageiros.filter(f => this.props.ehDeficiente(f.tipoEmissao)).length + total
    }

    recuperarTipoDocumento(tipoDocumento) {
        if (tipoDocumento) {
            const tipo = this.props.tiposDocumento.filter(f => f.tipo === tipoDocumento)[0];
            return {
                label: tipo.descricao,
                value: tipo.tipo
            }
        }
        return {
            label: 'RG',
            value: 'RG'
        }
    }

    preencherTarifaSeguroInfomadoNaModal(passageiro) {
        if (passageiro.opcaoDescontoMeia) {
            this.props.changeFieldValue('formIncluirPassageiro', 'opcaoDescontoMeia', passageiro.opcaoDescontoMeia);
        }
    }

    preencherValoresParaEdicao(passageiro) {
        if (passageiro.opcaoDescontoMeia) {
            this.props.changeFieldValue('formIncluirPassageiro', 'opcaoDescontoMeia', passageiro.opcaoDescontoMeia);
        } else if (this.props.opcaoDescontoMeiaPassagem === 'ANTT_EMPRESA') {
            this.props.changeFieldValue('formIncluirPassageiro', 'opcaoDescontoMeia', 'ANTT')
        } else {
            this.props.changeFieldValue('formIncluirPassageiro', 'opcaoDescontoMeia', this.props.opcaoDescontoMeiaPassagem);
        }

        if (passageiro.criancaColo) {
            this.props.changeFieldValue('formIncluirPassageiro', 'criancaColo', passageiro.criancaColo);
            this.props.changeFieldValue('formIncluirPassageiro', 'nomeCrianca', passageiro.criancaDto.nome);
            this.props.changeFieldValue('formIncluirPassageiro', 'cpfCrianca', passageiro.criancaDto.cpfCrianca);
            this.props.changeFieldValue('formIncluirPassageiro', 'dtNascimentoCrianca', passageiro.criancaDto.dtNascimentoCrianca);
            this.props.changeFieldValue('formIncluirPassageiro', 'documentoCrianca', passageiro.criancaDto.documentoCriacaComFoto);
        }
        this.props.changeFieldValue('formIncluirPassageiro', 'tipoEmissao', this.recuperarTipoEmissaoPassageiro(passageiro.tipoEmissao));
        
        if (this.state.naoHabilitadoCpfPassageiro) {
            this.props.changeFieldValue('formIncluirPassageiro', 'naoHabilitadoCpfPassageiro', true);
            this.props.changeFieldValue('formIncluirPassageiro', 'cpfPassageiro', '');
        } else {
            this.props.changeFieldValue('formIncluirPassageiro', 'naoHabilitadoCpfPassageiro', false);
            this.props.changeFieldValue('formIncluirPassageiro', 'cpfPassageiro', passageiro.cpfPassageiro);
        }

        this.props.changeFieldValue('formIncluirPassageiro', 'nomePassageiro', removerAcentos(passageiro.nome));
        this.props.changeFieldValue('formIncluirPassageiro', 'dtNascimento', passageiro.dtNascimento);
        this.props.changeFieldValue('formIncluirPassageiro', 'documentoPassegeiro', passageiro.documentoComFoto);
        this.props.changeFieldValue('formIncluirPassageiro', 'tipoDocumento',
            this.recuperarTipoDocumento(passageiro.tipoDocumento));
        this.props.changeFieldValue('formIncluirPassageiro', 'nis', passageiro.nis);
        this.props.changeFieldValue('formIncluirPassageiro', 'validade', passageiro.validade);
        this.props.changeFieldValue('formIncluirPassageiro', 'dtNascimetoIdoso', passageiro.dtNascimetoIdoso);
        this.props.changeFieldValue('formIncluirPassageiro', 'renda', passageiro.renda);
        this.props.changeFieldValue('formIncluirPassageiro', 'cargoProfissao', passageiro.cargoProfissao);
        this.props.changeFieldValue('formIncluirPassageiro', 'numeroDeficiente', passageiro.numeroDeficiente);
        this.props.changeFieldValue('formIncluirPassageiro', 'telefone', passageiro.telefone);
        this.props.changeFieldValue('formIncluirPassageiro', 'matricula', passageiro.matricula);
        this.props.changeFieldValue('formIncluirPassageiro', 'comAcompanhante', passageiro.comAcompanhante);
        
        const ddi = paisesDDI.find(it => it.id === passageiro.ddi);
        if (ddi) {
            this.props.changeFieldValue('formIncluirPassageiro', 'ddi', { label: `${ddi.pais} ${ddi.ddi}`, value: ddi.id });
        } else {
            this.props.changeFieldValue('formIncluirPassageiro', 'ddi', {label: 'Brasil +55', value: 32});
        }


    }

    preencherTipoOpcaoDescontoVolta(tipo) {
        if (this.props.ida.tipoVeiculo.includes('CONVENCIONAL')) {
            return 'NORMAL'
        }
        return tipo
    }

    handlePreencherComDadosIda(e) {
        const novaListaVolta = [];
        if (!e.target.value || e.target.value === 'false') {
            this.props.passageirosVolta.forEach((pass, index) => {
                const passIda = this.props.passageirosIda[index];
                // eslint-disable-next-line prefer-destructuring
                let valor = pass.valor;
                let taxaEmbarque = this.props.volta.taxaEmbarque;
                const tipoEmissao = this.preencherTipoOpcaoDescontoVolta(passIda.tipoEmissao);
                const tipoDocumento = this.recuperarTipoDocumento(passIda.tipoDocumento);
                if (this.props.ehMeiaPassagem(tipoEmissao)) {
                    if (passIda.opcaoDescontoMeia === 'ANTT') {
                        valor = this.props.volta.precoANTTMeia
                    } else {
                        // eslint-disable-next-line prefer-destructuring
                        valor = pass.valor
                    }
                }
                if (this.props.ehGratuidadeTotal(tipoEmissao)) {
                    valor = 0.00;
                    taxaEmbarque = 0.00
                }
                const novoPassVolta = {
                    nome: passIda.nome,
                    criancaColo: passIda.criancaColo,
                    cpfPassageiro: passIda.cpfPassageiro,
                    documentoComFoto: passIda.documentoComFoto,
                    dtNascimento: passIda.dtNascimento,
                    numeroPoltrona: pass.numeroPoltrona,
                    poltronaId: pass.poltronaId,
                    valor,
                    sentido: pass.sentido,
                    criancaDto: passIda.criancaDto,

                    tipoEmissao: tipoEmissao,
                    nis: passIda.nis,
                    validade: passIda.validade,
                    dtNascimetoIdoso: passIda.dtNascimetoIdoso,
                    renda: passIda.renda,
                    cargoProfissao: passIda.cargoProfissao,
                    numeroDeficiente: passIda.numeroDeficiente,
                    opcaoDescontoMeia: passIda.opcaoDescontoMeia,
                    telefone: passIda.telefone,
                    matricula: passIda.matricula,
                    taxaEmbarque,
                    tipoDocumento: tipoDocumento.value,
                    vendaSeguro: passIda.vendaSeguro,
                    ddi: passIda.ddi
                };

                novaListaVolta.push(novoPassVolta);
            })
        } else {
            this.props.passageirosVolta.forEach((pass) => {
                const novoPassVolta = {
                    nome: '',
                    criancaColo: false,
                    cpfPassageiro: '',
                    documentoComFoto: '',
                    dtNascimento: '',
                    numeroPoltrona: pass.numeroPoltrona,
                    poltronaId: pass.poltronaId,
                    valor: pass.valor,
                    sentido: pass.sentido,
                    criancaDto: {},

                    tipoEmissao: '',
                    nis: '',
                    validade: '',
                    dtNascimetoIdoso: '',
                    renda: '',
                    cargoProfissao: '',
                    numeroDeficiente: '',
                    telefone: '',
                    matricula: '',
                    opcaoDescontoMeia: '',
                    ddi: 32
                };
                novaListaVolta.push(novoPassVolta);
            })
        }
        this.props.adicionarPassageirosVolta(novaListaVolta);
    }

    preencherDadosComprador(passageiro) {
        if (passageiro) {            
            let ddi = passageiro.ddi
            if (passageiro.siglaPais) {
                ddi =  paisesDDI.find(it => it.sigla === passageiro.siglaPais).id
            }
            this.props.adicionarDadosComprador({
                cpfComprador: passageiro.cpfPassageiro,
                email: '',
                nomeComprador: passageiro.nome,
                telefoneComprador: passageiro.telefone,
                ddiComprador: ddi

            });
        }
    }

    handleRadioPagador(passageiro) {        
        // Verificar se já está processando para evitar loop infinito
        if (this.processingPagador) {
            return;
        }
        
        this.processingPagador = true;        
        let comprador = passageiro;
        
        if (this.state.naoHabilitadoCpfPassageiro || !passageiro.cpfPassageiro) {
            this.props.buscarUsuarioPorEmpresaNomeIdEmail(this.props.idUsuarioLogado, this.props.empresaSelecionada.id)
                .then(({payload: { data }}) => {                    
                    if (data && data.length) {
                        let ddi = passageiro.ddi;
                        if (data[0].siglaPais) {
                            ddi = paisesDDI.find(it => it.sigla === data[0].siglaPais).id;
                        }                        
                        comprador = Object.assign({}, passageiro, {
                            cpfPassageiro: data[0].cpfCnpj,
                            nome: data[0].nome,
                            telefone: data[0].telefone,
                            ddi: ddi,
                            pais: data[0].siglaPais
                        });
                    }
                })
                .finally(() => {
                    this.preencherDadosComprador(comprador);
                    this.finalizarProcessamentoPagador(passageiro);
                });
        } else {            
            this.preencherDadosComprador(comprador);
            this.finalizarProcessamentoPagador(passageiro);
        }
    }

    finalizarProcessamentoPagador(passageiro) {
        this.props.changeFieldValue('formIncluirPassageiro', 'pagador', passageiro.numeroPoltrona + passageiro.sentido);
        if (passageiro.sentido === 'IDA') {
            this.props.alterarCompradorIda(passageiro);
        } else {
            this.props.alterarCompradorVolta(passageiro);
        }
        
        // Liberar o processamento após um pequeno delay
        setTimeout(() => {
            this.processingPagador = false;
        }, 100);
    }

    removerPassageiro(passageiro) {
        if (passageiro.sentido === 'IDA') {
            const ida = this.props.passageirosIda.filter(f => f !== passageiro);
            this.props.adicionarPassageirosIda(ida)
        } else {
            this.props.adicionarPassageirosVolta(this.props.passageirosVolta.filter(f => f !== passageiro))
        }
    }

    prepararParaEdicao(pol) {
        this.props.changeFieldValue('formIncluirPassageiro', 'ddi', {label: 'Brasil +55', value: 32});
        this.props.selecionarPassageiro(pol)
    }

    exibirPassageiros(passageiros) {
        if (passageiros.length === 0) return ''
        return (
            <div className="vx-pass-grid">
                {passageiros.map((pol, index) => {
                    const isEmpty = !pol.nome
                    const sentidoClass = pol.sentido ? pol.sentido.toLowerCase() : 'ida'
                    return (
                        <div
                            className={`vx-pass-card${isEmpty ? ' vx-pass-card--empty' : ''}`}
                            key={`passageiro${pol.numeroPoltrona}${pol.sentido}`}
                        >
                            <div className="vx-pass-card-header">
                                <div className="vx-pass-seat-num">{pol.numeroPoltrona}</div>
                                <div className="vx-pass-header-info">
                                    <span className="vx-pass-header-label">Poltrona</span>
                                    <span className={`vx-pass-sentido-badge vx-pass-sentido-badge--${sentidoClass}`}>
                                        {pol.sentido || 'IDA'}
                                    </span>
                                </div>
                                <button
                                    type="button"
                                    className="vx-pass-remove-btn"
                                    onClick={() => this.removerPassageiro(pol)}
                                    title="Remover passageiro"
                                >
                                    <i className="material-icons">close</i>
                                </button>
                            </div>

                            <div className="vx-pass-body">
                                {isEmpty ? (
                                    <a
                                        className="vx-pass-empty-state"
                                        data-toggle="modal"
                                        data-target="#modalIncluirPassageiro"
                                        onClick={() => this.prepararParaEdicao(pol)}
                                    >
                                        <i className="material-icons">person_add</i>
                                        <span className="vx-pass-empty-label">Incluir passageiro</span>
                                    </a>
                                ) : (
                                    <React.Fragment>
                                        <div className="vx-pass-name">{pol.nome}</div>
                                        {pol.cpfPassageiro && <div className="vx-pass-cpf">{pol.cpfPassageiro}</div>}
                                        {pol.tipoEmissao && (
                                            <div className="vx-pass-chips">
                                                <span className="vx-pass-chip">{pol.tipoEmissao}</span>
                                            </div>
                                        )}
                                        <a
                                            className="vx-pass-edit-btn"
                                            data-toggle="modal"
                                            data-target="#modalIncluirPassageiro"
                                            onClick={() => this.prepararParaEdicao(pol)}
                                        >
                                            <i className="material-icons">edit</i>Editar passageiro
                                        </a>
                                        <div className="vx-pass-options">
                                            {this.exibirBotaoUsarPagador(pol, index)}
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    alterarSelecaoTarifaSeguro(passageiro) {
        const novoPassageiro = Object.assign({}, passageiro)
        novoPassageiro.vendaSeguro = !passageiro.vendaSeguro
        if (passageiro.sentido === 'IDA') {
            this.props.alterarPassageiroIda(novoPassageiro)
        } else {
            this.props.alterarPassageiroVolta(novoPassageiro)
        }

    }

    exibirBotaoUsarPagador(pol, index) {        
        if (pol.nome) {            
            if (index !== 0) {
                return (
                    <div>
                        <div className="card-text">
                            <input type="radio" onChange={() => this.handleRadioPagador(pol)}
                                   checked={!!pol.ehComprador}
                                   name='radioComprador' id='radioComprador'/> - Usar como comprador.
                        </div>
                        {this.props.vendaSeguroHabilitadaNaEmpresa ?
                            <div className="card-text">
                                <Field name={`vendaSeguro-${pol.poltronaId}`} type="checkbox"
                                       component={renderFieldCheck}
                                       label="Ativar seguro ao passageiro"
                                       onChange={() => this.alterarSelecaoTarifaSeguro(pol)}
                                       value={pol.vendaSeguro}
                                       css="form-check-input" readOnly={false}/>
                            </div>
                            : ''
                        }
                    </div>
                )
            }
            if (index === 0 && this.props.pagador !== pol.numeroPoltrona + pol.sentido) {
                return (
                    <div>
                        <div className="card-text">
                            <input type="radio" onChange={() => this.handleRadioPagador(pol)}
                                   checked={!!pol.ehComprador}
                                   name='radioComprador' id='radioComprador'/> - Usar como comprador.
                        </div>
                        {this.props.vendaSeguroHabilitadaNaEmpresa ?
                            <div className="card-text">
                                <Field name={`vendaSeguro-${pol.poltronaId}`} type="checkbox"
                                       component={renderFieldCheck}
                                       label="Ativar seguro ao passageiro"
                                       onChange={() => this.alterarSelecaoTarifaSeguro(pol)}
                                       value={pol.vendaSeguro}
                                       css="form-check-input" readOnly={false}/>
                            </div>
                            : ''
                        }
                    </div>
                )
            } else {
                return (
                    <div>
                        <div className="card-text">
                            <input type="radio" onChange={() => this.handleRadioPagador(pol)}
                                   checked={!!pol.ehComprador}
                                   name='radioComprador' id='radioComprador'/> - Usar como comprador.
                        </div>
                        {this.props.vendaSeguroHabilitadaNaEmpresa ?
                            <div className="card-text">
                                <Field name={`vendaSeguro-${pol.poltronaId}`} type="checkbox"
                                       component={renderFieldCheck}
                                       value={pol.vendaSeguro}
                                       label="Ativar seguro ao passageiro"
                                       onChange={() => this.alterarSelecaoTarifaSeguro(pol)}
                                       css="form-check-input" readOnly={false}/>
                            </div>
                            : ''
                        }
                    </div>
                )

            }

        }
        return ''

    }

    validarPreenchimentoCpfPassageiro(naoHabilitadoCpfPassageiro) {
        // Usar setState com callback para evitar re-renders desnecessários
        this.setState(prevState => {            
            if (prevState.naoHabilitadoCpfPassageiro !== naoHabilitadoCpfPassageiro) {                                
                return { naoHabilitadoCpfPassageiro }
            }
            return null; // Não atualiza se não houve mudança
        });
    }

    render() {
        const { passageirosIda, passageirosVolta } = this.props
        return (
            <React.Fragment>
                <Field name="pagador" type="hidden" component={renderFieldText} css="form-control col-md-12"/>

                <div className="vx-pass-section">
                    <span className="vx-seat-badge vx-seat-badge--ida">IDA</span>
                    <span className="vx-pass-section-title">Passageiros</span>
                    <span className="vx-pass-section-count">
                        {passageirosIda.length} {passageirosIda.length === 1 ? 'passageiro' : 'passageiros'}
                    </span>
                </div>
                {this.exibirPassageiros(passageirosIda)}

                {passageirosVolta.length > 0 && (
                    <div>
                        <div className="vx-pass-section">
                            <span className="vx-seat-badge vx-seat-badge--volta">VOLTA</span>
                            <span className="vx-pass-section-title">Passageiros</span>
                            <span className="vx-pass-section-count">
                                {passageirosVolta.length} {passageirosVolta.length === 1 ? 'passageiro' : 'passageiros'}
                            </span>
                        </div>
                        {!this.props.ehRemarcacao && (
                            <div className="vx-fill-from-ida">
                                <i className="material-icons">content_copy</i>
                                <span className="vx-fill-from-ida-label">Preencher volta com dados da ida</span>
                                <Field
                                    name="preencherComDadosIda"
                                    type="checkbox"
                                    component={renderFieldCheck}
                                    label=""
                                    css="form-check-input"
                                    readOnly={false}
                                    id="preencherComDadosIda"
                                    onChange={e => this.handlePreencherComDadosIda(e)}
                                />
                            </div>
                        )}
                        {this.exibirPassageiros(passageirosVolta)}
                    </div>
                )}

                <ModalIncluirPassageiro
                    preencherValoresParaEdicao={this.preencherValoresParaEdicao.bind(this)}
                    validarPreenchimentoCpfPassageiro={this.validarPreenchimentoCpfPassageiro.bind(this)}
                    ehGratuidadeTotal={this.props.ehGratuidadeTotal}
                    vendaSeguroHabilitadaNaEmpresa={this.props.vendaSeguroHabilitadaNaEmpresa}
                    ehIdoso100={this.props.ehIdoso100}
                    ehIdJovem100={this.props.ehIdJovem100}
                    ehDeficiente={this.props.ehDeficiente}
                    ehMeiaPassagem={this.props.ehMeiaPassagem}
                    passagueiroSelecionado={this.props.passagueiroSelecionado}
                />
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state) {
    return {
        passageirosIda: state.passageirosIda,
        passageirosVolta: state.passageirosVolta,
        ida: state.viagemIda,
        volta: state.viagemVolta,
        empresaSelecionada: state.empresaSelecionada,
        passagueiroSelecionado: state.passageiro,
        pagador: formValueSelector('formIncluirPassageiro')(state, 'pagador'),
        tipoEmissao: formValueSelector('formIncluirPassageiro')(state, 'tipoEmissao'),
        opcaoDescontoMeiaPassagem: state.opcaoDescontoMeiaPassagem,
        ehRemarcacao: state.remarcacao.reservasSelecionadas !== null,
        dadosPagamento: state.dadosPagamento,
        tiposEmissoesSelecionados: state.tiposEmissoesSelecionados,
        totaisGratuidade: state.quantidadeGratuidadeOcupadas,
        tiposDocumento: state.tiposDocumento,
        idUsuarioLogado: state.authentication.idUsuario,
        online: state.conexao.online
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        selecionarPassageiro,
        buscarOpcaoDescontoMeiaPassagem,
        adicionarDadosComprador,
        adicionarPassageirosVolta,
        adicionarPassageirosIda,
        selecionarPoltronas,
        poltronaGratuiraDisponivel,
        selecionarTiposEmisssoes,
        alterarPassageiroIda,
        alterarPassageiroVolta,
        vendaSeguroHabilitada,
        alterarCompradorIda,
        alterarCompradorVolta,
        buscarUsuarioPorEmpresaNomeIdEmail,
        buscarConfigGratuidadeTipoPreco
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formIncluirPassageiro',
    destroyOnUnmount: false,
    validate
})(AbaPassageiro));
